module.exports = __webpack_public_path__ + "static/media/BB.bfa698e6.png";